import moduleDescriptions from 'root/src/shared/descriptions/modules'
import { bannerHeaderModuleDescriptionLenses } from 'root/src/client/logic/header/lenses'

const { viewListModuleId } = bannerHeaderModuleDescriptionLenses

export default (state, { moduleId }) => viewListModuleId(moduleId, moduleDescriptions)
